import React, { Component } from "react";
import "./CheckBox.scss";
import { getRandomId } from "../../../utils/commonUtils";
import { CgRadioChecked } from 'react-icons/cg';

class CompCheckBox extends Component {
    constructor(props) {
        super(props);
        this.randomId = getRandomId();
    }

    renderLabel() {
        const { label, id = this.randomId } = this.props;
        return label ? (
            <label htmlFor={id} className="checkbox__label">
                {label}
            </label>
        ) : null;
    }

    render() {
        const { label, classes, changeHandler, checked, id = this.randomId } = this.props;

        return (
            <span className={`checkbox ${classes}`}>
                <input
                    onChange={changeHandler}
                    id={id}
                    className="checkbox__input"
                    type="checkbox"
                    name="check"
                    checked={checked}
                />
                <label htmlFor={id} className="checkbox__box">
                    <div className="icon-check"><CgRadioChecked /></div>
                    {/* <img className="icon-check" src={checkboxTick} alt="" /> */}
                </label>
                {this.renderLabel()}
            </span>
        );
    }
}

export default CompCheckBox;
